import React from 'react';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-solid-svg-icons';

import { func_validation, func_cookieSetting, func_datetime } from 'functions';

export const billOverviewColumns = {
    // Columns Array
    getColumns,

    // Columns
    getColumns_productCode,
    getColumns_unitPrice,
    getColumns_frequency,
    getColumns_chargeMethod,
    getColumns_outlets,
    getColumns_subscriptionMethod,
    getColumns_unitDiscountAmount,
    getColumns_subtotal,
}

function getColumns() {
    return [
        getColumns_productCode(),
        getColumns_unitPrice(),
        // getColumns_frequency(),
        getColumns_chargeMethod(),
        getColumns_outlets(),
        getColumns_subscriptionMethod(),
        getColumns_unitDiscountAmount(),
        getColumns_subtotal(),
    ];
}

function getColumns_productCode() {
    let columnClassName = "billOverview-tableColumn-productCode";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Product Code",
        // isHeaderColumnSortable: true,
        // sortValue: "productCode"
        id: "productCode",
        accessor: "productCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let row = func_validation.getObjectPropertyValue(props, "row");
            let rowDepth = func_validation.getObjectPropertyValue(row, "depth");

            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "";
            value_formatted = (rowDepth == 1)? "": value_formatted;

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_unitPrice() {
    let columnClassName = "billOverview-tableColumn-unitPrice";

    return {
        headerCellClassName: columnClassName + " justify-content-start",
        Header: "Unit Price (RM)",
        // isHeaderColumnSortable: true,
        // sortValue: "unitPrice"
        id: "unitPrice",
        accessor: "unitPrice",
        bodyCellClassName: columnClassName + " justify-content-end",
        Cell: (props) => {
            let row = func_validation.getObjectPropertyValue(props, "row");
            let rowDepth = func_validation.getObjectPropertyValue(row, "depth");

            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "";
            value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });
            value_formatted = (rowDepth == 1)? "": value_formatted;

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_frequency() {
    let columnClassName = "billOverview-tableColumn-frequency";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Frequency / mth",
        // isHeaderColumnSortable: true,
        // sortValue: "frequency"
        id: "frequency",
        accessor: "frequency",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let row = func_validation.getObjectPropertyValue(props, "row");
            let rowDepth = func_validation.getObjectPropertyValue(row, "depth");

            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "";
            value_formatted = (rowDepth == 1)? "": value_formatted;

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_chargeMethod() {
    let columnClassName = "billOverview-tableColumn-chargeMethod";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Charge Method",
        // isHeaderColumnSortable: true,
        // sortValue: "chargeMethod"
        id: "chargeMethod",
        accessor: "chargeMethod",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let row = func_validation.getObjectPropertyValue(props, "row");
            let rowDepth = func_validation.getObjectPropertyValue(row, "depth");

            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "";
            value_formatted = (rowDepth == 1)? "": value_formatted;

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_outlets() {
    let columnClassName = "billOverview-tableColumn-outlets";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Outlet(s)",
        // isHeaderColumnSortable: true,
        // sortValue: "outlets",
        id: "outlets",
        accessor: "outlets",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let row = func_validation.getObjectPropertyValue(props, "row");
            let rowDepth = func_validation.getObjectPropertyValue(row, "depth");

            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNotNullUndefined(value)? value:"-";
            if (rowDepth == 1 &&
                func_validation.isArrayNotEmpty(value_formatted)) {

                value_formatted = value_formatted.map((outlet, idx) => {
                    let outlet_formatted = func_validation.isStringTrimNotEmpty(outlet)? outlet: "";

                    return (
                        <div className={"noWrap-text-ellipsis billOverview-subrow-outletsColumn "} key={idx}>{outlet_formatted}</div>
                    );
                });
            }
            else if (func_validation.isStringTrimEmpty(value_formatted))
                value_formatted = "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        }
    }
}

function getColumns_subscriptionMethod() {
    let columnClassName = "billOverview-tableColumn-subscriptionMethod";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Subscription Method",
        // isHeaderColumnSortable: true,
        // sortValue: "subscriptionMethod"
        id: "subscriptionMethod",
        accessor: "subscriptionMethod",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let row = func_validation.getObjectPropertyValue(props, "row");
            let rowDepth = func_validation.getObjectPropertyValue(row, "depth");

            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "";
            value_formatted = (rowDepth == 1)? "": value_formatted;

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_unitDiscountAmount() {
    let columnClassName = "billOverview-tableColumn-unitDiscountAmount";

    return {
        headerCellClassName: columnClassName + " justify-content-start",
        Header: "Unit Discount Amount (RM)",
        // isHeaderColumnSortable: true,
        // sortValue: "unitDiscountAmount"
        id: "unitDiscountAmount",
        accessor: "unitDiscountAmount",
        bodyCellClassName: columnClassName + " justify-content-end",
        Cell: (props) => {
            let row = func_validation.getObjectPropertyValue(props, "row");
            let rowDepth = func_validation.getObjectPropertyValue(row, "depth");

            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "";
            value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });
            value_formatted = (rowDepth == 1)? "": value_formatted;

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
        width: 250
    }
}

function getColumns_subtotal() {
    let columnClassName = "billOverview-tableColumn-subtotal";

    return {
        headerCellClassName: columnClassName + " justify-content-end",
        Header: "Subtotal (RM)",
        // isHeaderColumnSortable: true,
        // sortValue: "subtotal"
        id: "subtotal",
        accessor: "subtotal",
        bodyCellClassName: columnClassName + " justify-content-end",
        Cell: (props) => {
            let row = func_validation.getObjectPropertyValue(props, "row");
            let rowDepth = func_validation.getObjectPropertyValue(row, "depth");

            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "";
            value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });
            value_formatted = (rowDepth == 1)? "": value_formatted;

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}